'use strict';

angular.module('ClinicApp').directive('notificationsBanner', (ServiceWorkerService, GrowlService, OCLogUtil) => ({
  restrict: 'A',
  templateUrl: '/views/directives/_notifications-banner.html',
  scope: {},
  link: ($scope) => {
    $scope.status = ServiceWorkerService.getStatus();
    $scope.showBanner = $scope.status === ServiceWorkerService.NOTIFICATION_STATUS.NOT_GRANTED;

    // Check if the banner was previously hidden
    if (localStorage.getItem('notificationBannerdissmised') === 'true') {
      $scope.bannerDismissed = true;
    }

    $scope.$watch(
      ServiceWorkerService.getStatus,
      (newStatus) => {
        $scope.status = newStatus;
        $scope.showBanner = (
          $scope.status === ServiceWorkerService.NOTIFICATION_STATUS.NOT_GRANTED
          && !$scope.bannerDismissed
        );
      },
    );
    $scope.enableNotifications = async () => {
      try {
        await ServiceWorkerService.enableNotifications();
        $scope.status = ServiceWorkerService.getStatus();

        if ($scope.status === 'connected') {
          GrowlService.success('You will now receive notifications.', { title: 'Notifications enabled' });
        } else if ($scope.status === 'denied') {
          GrowlService.warning('Please enable notifications in your browser settings.', { title: 'Notifications not enabled' });
        }
      } catch (error) {
        OCLogUtil.rollbar.error('Error enabling notifications', error);
        GrowlService.error(
          [
            'There was an error enabling notifications.',
            'You may need to enable settings in your browser.',
            'Please see our help article to find out how to enable notifications for your browser.',
            ServiceWorkerService.getZendeskHelpLink(),
          ].join('<br/>'),
          {
            title: 'Error enabling notifications',
            ttl: -1,
          },
        );
      }
    };
    $scope.hideBanner = () => {
      $scope.showBanner = false;
      localStorage.setItem('notificationBannerdissmised', 'true'); // Store the preference
    };
  },
}));
